// extracted by mini-css-extract-plugin
module.exports = {"search__box":"SearchBox_search__box__18iD7","search__input":"SearchBox_search__input__2IWsX"};